// extracted by mini-css-extract-plugin
export var alertIcon = "_t0-0";